import angular from 'angular';
import uiRouter from 'angular-ui-router';
import VerifyEmailComponent from './verify-email.component';
import routing from './verify-email.routes';

export default angular
  .module('oauth.verify-email', [uiRouter])
  .config(routing)
  .component('verifyEmail', VerifyEmailComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/oauth/verify-email/index.js